/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'

/**
 *
 * @export
 * @interface EnvelopedDocumentUpdateAdmin
 */
export interface EnvelopedDocumentUpdateAdmin {
  /**
   *
   * @type {any}
   * @memberof EnvelopedDocumentUpdateAdmin
   */
  body: any | null
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedDocumentUpdateAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedDocumentUpdateAdmin interface.
 */
export function instanceOfEnvelopedDocumentUpdateAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedDocumentUpdateAdminFromJSON(json: any): EnvelopedDocumentUpdateAdmin {
  return EnvelopedDocumentUpdateAdminFromJSONTyped(json, false)
}

export function EnvelopedDocumentUpdateAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedDocumentUpdateAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: json['body'],
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedDocumentUpdateAdminToJSON(
  value?: EnvelopedDocumentUpdateAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: value.body,
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
